const correctActive = () => {
    const mainMenuParent = document.getElementById('navbarSupportedContent');
    let mainMenuList = undefined;
    if(mainMenuParent !== null){
        mainMenuList = mainMenuParent.querySelector('.navbar-nav');
    }

    if(mainMenuList !== undefined){
        const menu = mainMenuList;
        const baseUrl = window.location.href;

        const allLinks = menu.querySelectorAll('a');
        let hashes = [];
        allLinks.forEach(link => {
            let parent = link.parentNode;
            if(link.href.includes('#')){
                link.classList.remove('active');
                parent.classList.remove('active');
                parent.classList.remove('current-menu-item');
                if(link.href.split('#')[0] === baseUrl && link.href.split('#')[1] !== ''){
                    hashes[link.href.split('#')[1]] = link;
                }

            }

        })
        const hashKeys = Object.keys(hashes);
        document.addEventListener('scroll', ev => {
            if(timer){
                window.clearTimeout(timer);
            }
            let timer = window.setTimeout( () =>{
                hashKeys.forEach(key => {
                    if(document.getElementById(key)){
                        const el = document.getElementById(key);
                        const l = hashes[key];
                        let bounding = el.getBoundingClientRect();
                        if (
                            bounding.top >= 0 &&
                            bounding.left >= 0 &&
                            bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
                            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
                        ) {
                            l.classList.add('active');
                        } else {
                            l.classList.remove('active');
                        }
                    }
                })
            }, 1000);
        })
    }

}
export default correctActive;